import axios from 'axios';
import moment from 'moment';
import { API_LOCAL, ORGANIZATION_ALIAS, COURSE_ALIAS, STRIPE_BASIC_PRODUCT_ID } from './constants';
import { Auth, Storage, API } from 'aws-amplify';
import { faBellSlash } from '@fortawesome/free-solid-svg-icons';

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error && error.response && error.response.status === 401) {
      window.location = '/signin';
    }
    return error;
  }
);

const apiManager = {
  getSystemSettings: async function(org = false) {
  
    // const url = API_LOCAL + 'users/system/settings';
    let url = API_LOCAL + 'system/settings';
    if (org) {
      url += `?org=${org}`
    }
    try {
     // let headers = await this.getHeaders();

      const result = await axios.get(url);

      return result.data;
    } catch (ex) {
      console.log(ex);
    }
    return [];
  },
  confirmUser: async (params) => {
      debugger;
    const url = API_LOCAL + 'auth/confirm';
    try {
        params.orgAlias = ORGANIZATION_ALIAS;
        const body = {params};
       
      const result = await axios.put(url, body ) //, { headers }
      console.log('confirm user response ', result)
      
      return result.data.data;
    } catch (ex) {
      console.log(ex);
    }
    return [];
  },
  getClassCode: async function() {
  const cogInfo = localStorage.user;
  let userId = "12345";
  let email = 'none@none.com'
  if( cogInfo ) {
      const cjson = JSON.parse(cogInfo);
      userId = cjson.sub;
      email = cjson.email;
  }

  const url = `${API_LOCAL}classCode/${userId}/${email}`;
  try {
    // let headers = await this.getHeaders();
   
    const result = await axios.post(url, {returnURL: document.URL});
    return result.data;
  } catch (ex) {
      let x = ex;
    
    console.log(ex);
  }
  return [];
  },
  getClassProgress: async function(org, course, impersonate = null) {
    const cogInfo = localStorage.user;

    debugger;
    let userId = "";
    if(impersonate) {
      userId = impersonate
    } else if( cogInfo ) {
        const cjson = JSON.parse(cogInfo);
        userId = cjson.sub;
    }


    // dummy user id for testing
    // userId = "813f427a-05fd-4e83-bd49-xxxx";
    const url = `${API_LOCAL}classProgress/${org}/${course}/${userId}`;
    try {

    const headers = await this.getHeaders();
    // var config = {
    //     method: 'post',
    //     url: 'https://umu8ltniff.execute-api.us-east-1.amazonaws.com/stage/api/v1/classProgress/sha/regenag-101',
    //     headers: { 
    //       'token': 'eyJraWQiOiJhSUZpUG1pXC9VOXJiK1F5a2ZacnBEUnJZdWRIMnhqXC9aeFZzS1BUN0lsZms9IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiJlY2FmYTFhYi0wNWY3LTQ5NDMtODk5OC03ZDIzNjAxOWJjMGUiLCJjdXN0b206aXNTdWJzY3JpYmVkIjoidHJ1ZSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtZWFzdC0xLmFtYXpvbmF3cy5jb21cL3VzLWVhc3QtMV9VQThpY0s0R28iLCJjb2duaXRvOnVzZXJuYW1lIjoiZWNhZmExYWItMDVmNy00OTQzLTg5OTgtN2QyMzYwMTliYzBlIiwiYXVkIjoiZHNicXZwbnVhamRkYjBnMDE2YzRhZ2o5cSIsImV2ZW50X2lkIjoiNmQ3YzI0N2UtZjIwNS00MGNlLTkyNDMtYWM2ZDcxZDU1NDc0IiwidG9rZW5fdXNlIjoiaWQiLCJjdXN0b206c3ViRXhwIjoiMTYzNDA3MzA2OSIsImF1dGhfdGltZSI6MTYwODA3NjUwNCwiZXhwIjoxNjA4MjM5NTY0LCJpYXQiOjE2MDgyMzU5NjQsImVtYWlsIjoiZWRkaWUrc2hhMDVAY3VydmUxMC5jb20ifQ.MrkfQo4-kXdiMLRj7ZkJ7F5M_dvp9IdL6EBlqpRAs-cAvLfc-RG6QSIkDt8fjG1DTrsTe7HW1xCXaQDYy_QQpEsunGwD9O_2daDybMwqdYgSjhDNMvsVPJ7As4XiA8gHI7KMrb5j5FTW0ZfC2LNMjUVfH4aSLTG7TwwuEd8iE0lPO_8FMbysUCQiqWlPkm9Z_vSRqewEXU36zAzJOeCQ0mItg35zYUyioj26QmjRcDKuI2WzB2DDVZo4KMMt4qAJru7jMN84e_S62kaCUiQnNYioSvTyFz6SgC40sCzbSQRVukbfk4owrR27QrWFZG8azGeyq9tfc2JCnCGx5zDIaw',
    //     }
    //     };
    // debugger;
    //   const result = await axios(config );
      const result = await axios.get(url);

      return result.data;
    } catch (ex) {
        let x = ex;
      debugger;
      console.log(ex);
    }
    return [];
  },
  currentSession: async function() {
    const authData = await Auth.currentSession();
    localStorage.setItem('user', JSON.stringify(authData.idToken.payload));
    return authData;
  },
  currentAttributes: async function () {
    const authData = await Auth.currentAuthenticatedUser();
    // localStorage.setItem('user', JSON.stringify(authData.idToken.payload));
    const currentAttributes = await Auth.userAttributes(authData);
    const attributes = {};
    currentAttributes.map( att => (attributes[att.Name] = att.Value))
    return attributes;  
  },
  signIn: async function(email, password) {
    const results = {
      authData: null,
      signedIn: false,
    };

    const authData = await Auth.signIn(email, password);
    if (authData && authData.challengeName && authData.challengeName === 'NEW_PASSWORD_REQUIRED') {
        results.signedIn = true;
        results.authData = authData;
        results.changePassword = true;
    }
    if (authData && authData.signInUserSession && authData.signInUserSession.idToken) {
      results.signedIn = true;
      results.authData = authData;
      results.changePassword = false;

      localStorage.setItem('user', JSON.stringify(authData.attributes));

      // next record this login time
      const loginurl = `${API_LOCAL}user/update/login`;
      debugger;
      const resultlogin = await axios.post(loginurl, {email});

      // finally, get the user's db info
      // **** user/me *****
      const url = `${API_LOCAL}getUsers`;
      debugger;
      const result = await axios.post(url, {me: authData.username});
      const userInfo = result.data.response[0];
      debugger;
      const usertype = userInfo && userInfo.roles && userInfo.roles.length > 0 && (userInfo.roles.includes('admin-super') || userInfo.roles.includes('admin-org') || userInfo.roles.includes('admin-orgViewer') || userInfo.roles.includes('admin-org')) ? 'admin' : 'user';
      localStorage.setItem('isAdmin', usertype);
      localStorage.removeItem('demoMode');
      let adminType = '';
      debugger;
      if( userInfo && userInfo.roles) {
          userInfo.roles.forEach((role) => {
              if(role === 'admin-super') {
                adminType = 'admin-super';
              } else if (role === 'admin-org' && adminType !== 'admin-super') {
                  adminType = 'admin-org';
              } else if (role === 'admin-orgViewer' && adminType !== 'admin-super' && adminType !== 'admin-org') {
                  adminType = 'admin-orgViewer';
              }
              if( role === 'demo') {
                  localStorage.setItem('demoMode', true);
              } 
          })
        }
      localStorage.setItem('adminType', adminType);
      debugger;
    }
    return results;

  },
  signUp: async function(params) {
    try {

      const newUser = await Auth.signUp({
        username: params.email,
        firstName: params.firstname,
        lastName: params.lastname,
        password: params.password,
        email_verified: 'true',
        attributes: {
          'custom:firstName': params.firstName,
          'custom:lastName': params.lastName,
          'custom:isSubscribed': 'false', // not subscribed by default
          'custom:subExp': params.subExp, // expires today
          'custom:phone': params.phone,
          'custom:referralURL': params.referral,
        },
      });
      debugger;

      // now create their account in the users_cognito collection
      
      params.cognitoId = newUser.userSub;
      params.source = '';
      params.registrations = [
        {
            "organization" : {
                "_id" : "", 
                "name" : ORGANIZATION_ALIAS, 
                "memberTypes" : [
                    "TBD (Default)"
                ], 
                "group" : "", 
                "referralUrl" : params.referral ,
                "referredBy" : "self", 
                "subscriptions" : []
            }
        }
      ]
      const url = `${API_LOCAL}user/update/create`;
      try {
          const results = await axios.post(url, params);
          debugger;
      } catch (err) {
          console.log('create error: ', err);
          debugger;
      }
      return newUser;
    } catch (err) {
      console.log(err);
      debugger;
      return err;
    }
  },
  adminCreateUser: async function (payload, sendInvite = false, isBulk) {
    let results = {};
    // NOTE: need to call the congintouser create, then the db user update
    let cognitoResults = false;
    const cognitoCreateUrl = `${API_LOCAL}user/updateCognitoUser/create`;
    try {
        cognitoResults = await axios.post(cognitoCreateUrl, payload);
        const isError = cognitoResults.data.status === 'success' && cognitoResults.data.newUser.status === 'error'
        const isBulkDuplicate = isBulk && isError && cognitoResults.data.newUser.message === "An account with the given email already exists."
        if(isError && !isBulkDuplicate) {
          return cognitoResults.data.newUser.message;
        }
        if (!isBulkDuplicate){
          payload.cognitoId = cognitoResults.data.newUser.created.User.Username;
          const url = `${API_LOCAL}user/update/create`;
          try {
              if (sendInvite) payload.sendInvite = true;
              results = await axios.post(url, payload);
          } catch (err) {
              console.log('create error: ', err);
              debugger;
          }
        }
        if(isBulkDuplicate){
          const updateUrl = `${API_LOCAL}user/update/update`;
          try {
              payload.isBulkDuplicate = isBulkDuplicate
              results = await axios.post(updateUrl, payload);
          } catch (err) {
              console.log('bulk update error: ', err);
          }
        }
    } catch (err) {
        console.log('create error: ', err);
        debugger;
        return(cognitoResults)
    }
    return results;
  },
  adminUpdateUserProfile: async function (payload) {
    let results = {};
    const id = payload._id;

    // NOTE: need to call the congintouser update, then the db user update
    let cognitoResults = false;
    const cognitoUpdateUrl = `${API_LOCAL}user/updateCognitoUser/update`;
    try {
        cognitoResults = await axios.post(cognitoUpdateUrl, payload);
        debugger;
    } catch (err) {
        console.log('create error: ', err);
        return (cognitoResults);
        debugger;
    }

    // only get here if cognito succeeded
    const url = `${API_LOCAL}user/update/update`;
    try {
        results = await axios.post(url, payload);
        debugger;
    } catch (err) {
        console.log('create error: ', err);
        debugger;
    }

    return results;
  },
  adminUpdateUserLoginDate: async function (payload) {
    let results = {};

    // only get here if cognito succeeded
    const url = `${API_LOCAL}user/update/login`;
    try {
        results = await axios.post(url, payload);
        debugger;
    } catch (err) {
        console.log('create error: ', err);
        debugger;
    }

    return results;
  },
  adminUpdateSubscription: async function (payload) {
      let results = {};
      const id = payload._id;
      
      // NOTE: need to call the congintouser update, then the db user update
      // in this case, only if a stripe subscription
      if (payload.organization_subscriptions[0] && payload.organization_subscriptions[0].processedBy === 'Stripe') {
          let cognitoResults = false;
          const cognitoUpdateUrl = `${API_LOCAL}user/updateCognitoUser/subscription`;
          try {
              cognitoResults = await axios.post(cognitoUpdateUrl, payload);
              debugger;
          } catch (err) {
              console.log('create error: ', err);
              return (cognitoResults);
              debugger;
          }
      }

      // only get here if cognito succeeded
      const url = `${API_LOCAL}user/update/update`;
      try {
          results = await axios.post(url, payload);
          debugger;
      } catch (err) {
          console.log('create error: ', err);
          debugger;
      }

      return results;
  },
  adminDeleteUser: async function (payload) {
      let results = {};
      const id = payload._id;

      // NOTE: need to call the congintouser update, then the db user update

      let cognitoResults = false;
      const cognitoUpdateUrl = `${API_LOCAL}user/updateCognitoUser/delete`;
      try {
          cognitoResults = await axios.post(cognitoUpdateUrl, payload);
          debugger;
      } catch (err) {
          console.log('create error: ', err);
          return (cognitoResults);
          debugger;
      }


      // only get here if cognito succeeded
      const url = `${API_LOCAL}user/update/delete`;
      try {
          results = await axios.post(url, payload);
          debugger;
      } catch (err) {
          console.log('create error: ', err);
          debugger;
      }

      return results;
  },
  adminChangePassword: async function (payload) {
      let results = {};
      const headers = await this.getHeaders();
      // headers.role = 'admin';
      const url = `${API_LOCAL}user/updateCognitoUser/password`;
      try {
          results = await axios.post(url, payload);
          debugger;
      } catch (err) {
          console.log('password change error: ', err);
          debugger;
      }

      return results;
  },
  updateUserAttributes: async function(attributes) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const result = await Auth.updateUserAttributes(user, attributes);
      return result;
    } catch (err) {
      console.log(err);
      return err;
    }
  },
  validateCode: async function(email, confirmationCode, password) {
    const response = {
      confirmed: false,
      signedIn: false,
      userInfo: null,
    };
    response.confirmed = await Auth.confirmSignUp(email, confirmationCode);

    response.userInfo = await Auth.signIn(email, password);
    localStorage.setItem('user', JSON.stringify(response.userInfo.attributes));
    if (response.userInfo && response.userInfo) {
      response.signedIn = true;
    }
    return response;
  },
  resendCode: async function(username) {
    let response = 'resent';
    try {
      await Auth.resendSignUp(username);
    } catch (err) {
      console.log('error resending code: ', err);
      response = `Error: ${err.message}`;
    }
    return response;
  },
  signOut: async function() {
    await Auth.signOut();
  },
  forgotPassword: async function(email) {

    // first we need to confirm the email address...
    let results = {};
    debugger;
    // NOTE: need to call the congintouser create, then the db user update
    let cognitoResults = false;
    const cognitoVerifyURL = `${API_LOCAL}user/updateCognitoUser/verifyEmail`;
    try {
        const payload = {email}
        cognitoResults = await axios.post(cognitoVerifyURL, payload);
        console.log(cognitoResults)
    } catch (err) {
        console.log('create error: ', err);
        debugger;
        return(cognitoResults)
    }

    return await Auth.forgotPassword(email);
  },
  resetMyPassword: async function(email, code, password) {
    let result = 'success';
    try {
      result = await Auth.forgotPasswordSubmit(email, code, password);
      return result;
    } catch (err) {
      result = err;
      return {error: result}
    }
  },
  changePassword: async function (email, oldPassword, newPassword) {
    let result = {
        error: false,
        result: null,
    };
    const authData = await Auth.signIn(email, oldPassword);
 
    try {
       result.result = await Auth.completeNewPassword(
            authData,
            // oldPassword,
            newPassword,
            {}
        );
      return result;
    } catch (err) {
        result.error = err;
        debugger;
      return (result)
    }
  },
  getHeaders: async function() {

    const { accessToken, idToken } = await this.currentSession();

    const headers = {
      token: idToken.jwtToken // WARNING: idToken contains Cognito Attributes, whereas accesToken does not!
      //localStorage.getItem('token'), // <--- this is the old way. Amplify already has localStorage for: acces, id, and refresh tokens!
    };
    return headers;
  },
  getSubscription: async function() {
    const url = API_LOCAL + `subscriptions/get`;
    try {
      const result = await axios.get(url, { headers: await this.getHeaders() });

      return result.data;
    } catch (ex) {
      console.log(ex);
    }
    return {};
  },
  getCourseSettings: async function (stripePrice) {
    const settings = await this.getSystemSettings(ORGANIZATION_ALIAS);
    const { courses } = settings.results.org;

    const [course] = courses.filter(course => (course.stripeConfig.basicProductPlan === stripePrice || course.stripeConfig.basicProductPlanRenewal === stripePrice))
    console.log(course);
    return course;
  },
  // Create new subscription info (to a stripe product - not a plan) in local db
  // NOTE: this process will eventually replace using Cognito to store subscription status
  createUserSubscription: async function (stripeCheckoutSession) {
    
    const { id, customer, customer_email, payment_intent, line_items } = stripeCheckoutSession;
    
    // Get user sub
    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    console.log('line_items', line_items.data);
    // Generate "subscription" templates for each stripe product
    let subTemplates = [];
    for(let i=0; i < line_items.data.length; i++) { // .map,.filter,.forEach don't play with async/await :(
      const item = line_items.data[i];
      console.log('line item: ', item);
      const courseConfig = await this.getCourseSettings(item.price.id)
      subTemplates.push({
        cognitoId: (user && user.sub) ? user.sub : '',
        courseNameAlias: courseConfig.alias, // COURSE_ALIAS,
        orgAlias: ORGANIZATION_ALIAS,
        subscription: {
          courseNameAlias: courseConfig.alias, // COURSE_ALIAS, 
          startDate: moment().valueOf(), // Now as Epoch
          endDate: moment().add(1, 'Y').valueOf(), // 1 Year from Now as Epoch
          isSubscribed: true, 
          active: true,
          status: 'active',
          stripeData: {
            customerId: customer,
            productId: item.price.id,
            sessionId: id,
            paymentIntent: payment_intent,
          },
          processedBy: "Stripe"
        }
      });
    };

    // const subTemplates = line_items.data.map(item => {
    //   console.log('line item: ', item);
    //   const courseConfig = await this.getCourseSettings(item.price.id)
    //   return {
    //     cognitoId: (user && user.sub) ? user.sub : '',
    //     courseNameAlias: courseConfig.alias, // COURSE_ALIAS,
    //     orgAlias: ORGANIZATION_ALIAS,
    //     subscription: {
    //       courseNameAlias: courseConfig.alias, // COURSE_ALIAS, 
    //       startDate: moment().valueOf(), // Now as Epoch
    //       endDate: moment().add(1, 'Y').valueOf(), // 1 Year from Now as Epoch
    //       isSubscribed: true, 
    //       active: true,
    //       stripeData: {
    //         customerId: customer,
    //         productId: item.price.id,
    //         sessionId: id,
    //         paymentIntent: payment_intent,
    //       },
    //       processedBy: "Stripe"
    //     }
    //   };
    // });

    // Create subscription Template
    // const createSubTemplate = {
    //   cognitoId: (user && user.sub) ? user.sub : '',
    //   courseNameAlias: COURSE_ALIAS,
    //   orgAlias: ORGANIZATION_ALIAS,
    //   subscription: {
    //     courseNameAlias: COURSE_ALIAS, 
    //     startDate: moment().valueOf(), // Now as Epoch
    //     endDate: moment().add(1, 'Y').valueOf(), // 1 Year from Now as Epoch
    //     isSubscribed: true, 
    //     active: true,
    //     stripeData: {
    //       customerId: customer,
    //       productId: stripeProductId,
    //       sessionId: id,
    //       paymentIntent: payment_intent,
    //     },
    //     processedBy: "Stripe"
    //   }
    // };
    

    // Send new sub to user update endpoint (behind VPC)
    const url = `${API_LOCAL}user/update/stripesub`;

    try {
      let result = {};

      // Returns: cognito_users object - hack for multi-product is to loop and keep assigning result over and over
      for (let i=0; i < subTemplates.length; i++) {
        result = await axios.post(url, subTemplates[i], await apiManager.getHeaders()).catch(e => console.log(e.message));
      }
      
      return result.data.data;
    } catch (ex) {
      console.log(ex);
    }
    return {};

  },
  // Generate new checkout session (outside VPC) before we send user to Stripe Checkout
  createCheckoutSession: async (stripeSession) => {
    const url = API_LOCAL + 'subscriptions/create-checkout-session';
    try {
      // TODO: get JWT via Amplify??
      // NOTE: Headers not working?! 
      // let headers = this.getHeaders();

      // Returns: checkout.session object
      const result = await axios.post(url, stripeSession).catch(e => console.log(e.message));
      
      return result.data.data;
    } catch (ex) {
      console.log(ex);
    }
    return [];
  },
  // Retrieve as much info we can from Stripe (outside VPC)
  getCheckoutSession: async (stripeSessionId) => {
    const url = API_LOCAL + 'subscriptions/get-checkout-session';

    try {
      // Returns existing: checkout.session object
      // https://stripe.com/docs/api/checkout/sessions/retrieve?lang=node
      const result = await axios.post(url, { stripeSessionId }).catch(e => console.log(e.message));
      console.log('getCheckoutSession', result);
      if(result && result.data) {
        const { id, customer, customer_email, payment_intent, line_items } = result.data.data
        
        return {
          id,
          customer,
          customer_email,
          payment_intent,
          line_items,
          // stripeProductId: STRIPE_BASIC_PRODUCT_ID
        }
      }

    } catch (ex) {
      console.log(ex);
    }
    return {};
  },
  // admin endpoint
  getUserList: async (payload) => {
    const url = `${API_LOCAL}getUsers`;
    try {
        const result = await axios.post(url, payload);

      return result.data;
    } catch (ex) {
      console.log(ex);
    }
    return [];
  },
  getUserMe: async (id, orgAlias) => {
    const url = `${API_LOCAL}getUsers`;
    try{
      const result = await axios.post(url, {me: id, orgAlias });
      return result.data.response[0];
    } catch (ex) {
      console.log(ex)
    }
    return []
  },
  uploadToS3: async (url, file, assetId) => {
    // Amplify version
        // try{
        //  const result = await Storage.put(file.name, file, {
        //    contentType: 'text/csv'
        //  })
        //  return result
        // } catch (ex){
        //   console.log(ex)
        //   return ex
        // }
        // return ''

      // Direct to S3 version
      try {   
        const context = this;
        var reader = new FileReader();
        reader.onload = async function() { 
            var arrayBuffer = this.result; 

            const response = await fetch( 
                new Request(url, {
                  method: 'PUT',
                  headers: {},
                  body: arrayBuffer
                })
              );
              
              if (response.status !== 200) { 
                console.log(response); 
              }
              else {
                if(assetId){
                    await context.setAsset(assetId)
                }
              } 
        }
        reader.readAsArrayBuffer(file);
        return { key: '' }; 
      }
      catch(ex){   
          console.log(ex)
      }
      return { key: '' };
  },
  sendBulkInvites: async (users) =>{
    //TO DO CREATE END POINT AND UPDATE URL
    const url = (API_LOCAL) + 'admins/bulk-invite';
        try {
            const result = await axios.post(url, {users}, {headers: await apiManager.getHeaders() } );
            if( result.data.validCSV === false) {
                alert('Sorry, the CSV format is incorrect. The column headers do not match the expected values.');
            }
            return result.data;
        }
        catch (ex) {
            console.log(ex)
        }
        return {};
  },
  processCSV: async (key) =>{
    //TO DO CREATE END POINT AND UPDATE URL
    const url = (API_LOCAL) + 'files/process/csv';
        try {
            const result = await axios.post(url, {key}, { headers: this.getHeaders() });
            if( result.data.validCSV === false) {
                alert('Sorry, the CSV format is incorrect. The column headers do not match the expected values.');
            }
            return result.data;
        }
        catch (ex) {
            console.log(ex)
        }
        return {};
  }
};


export default apiManager;
